import request from "./request";

const ExpertSessionsService = {

    GetAll: async (context, signal) => {
        return await request.sendRequest(`/Session/all`, context.token, signal);
    },
    Get: async (id, context, signal) => {
        return await request.sendRequest(`/Session/${id}`, context.token, signal);
    },
    GetSessionAvailable: async (context, signal) => {
        return await request.sendRequest(`/Sessions/available`, context.token, signal);
    },
    GetView: async (id, context, signal) => {
        return await request.sendRequest(`/Session/view/${id}`, context.token, signal);
    },
    GetCourseId: async (courseId, context, signal) => {
        return await request.sendRequest(`/Session/course/${courseId}`, context.token, signal);
    },
    GetInstructorId: async (id, context, signal) => {
        return await request.sendRequest(`/Session/instructors/${id}`, context.token, signal);
    },
    GetSearch: async (searchText, context, signal) => {
        return await request.sendRequest(`/Session/search/${searchText}`, context.token, signal);
    },
    Remove: async (id, context) => {
        return await request.sendDeleteRequest(`/Session/${id}`, context.token);
    },
    Save: async (payload, context, signal) => {
        return await request.sendPostRequest(`/Session`, payload, context, signal);
    },
    GetRegisterationsId: async (sessionId, context, signal) => {
        return await request.sendRequest(`/Session/registrations/${sessionId}`, context.token, signal);
    },

   update: async (id, status, context) => {
        return await request.sendPutRequest(`/Session/status/${id}/${status}`, context);
    },
    
   Register: async (sessionId, context) => { 
    return await request.sendPostRequest( `/Session/register/${sessionId}`, null, context );
  },
    Cancel: async (sessionId, context) => {
        return await request.sendDeleteRequest(`/Session/unregister/${sessionId}`, context.token);
    },

};

export default ExpertSessionsService;